import { Toast } from '@iyunbao/components';

import fetchAPI from '../../utils/fetchAPI';
import config from '../../config';

// 数据绑定表
export const dataBindMaps = {
  certiType: 'certType',
  certiNo: 'certNo',
  cityAddress: 'address',
  idexpDate: 'validate',
  effectiveDate: 'validateBegin',
};

// 证件类型对应表
export const certTypeMaps = {
  SFZ: '身份证',
  HKB: '户口薄',
  JG: '军官证',
  JRZ: '军人身份证',
  GAT: '港澳台居民往来内地通行证',
  GA: '港澳通行证',
  TW: '台湾通行证',
  CSZ: '出生证',
  HZ: '护照',
  JGZ: '警官证',
  TBZ: '台胞证',
  GT: '港台通行证',
  GATTB: '港澳台同胞证',
  GTTB: '港台同胞证',
  SWDJ: '税务登记证',
  YYZZ: '营业执照',
  ZZJG: '组织机构代码证',
  TYSHXY: '统一社会信用代码',
};

// 选择列表
export const addressBookSelectData = [
  {
    label: '导入客户信息',
    desc: '用于已建客户，一键导入投保人姓名、身份证、职业、地址等',
    icon: 'tongxunxinxi',
    key: 'select_1',
    isApp: true,
    log: 'openAddressBook',
    action: {
      type: 'openAddressBook',
    },
  },
  {
    label: '识别证件',
    desc: '可自动识别证件图片信息，方便您快速录入',
    icon: 'saomiao',
    key: 'select_2',
    action: {
      type: 'imageOCR',
    },
  },
];

// 证件上传页面
export const certUploadPage = [
  {
    id: '1',
    title: '身份证人像面',
    type: 'add',
    errorCode: 1,
    message: '请上传人像面证件照片',
    front: 'front',
    src: 'https://static.iyb.tm/web/h5/passport/user/auth/id_card.png',
  },
  {
    id: '2',
    title: '身份证国徽面',
    type: 'add',
    errorCode: 1,
    message: '请上传国徽面证件照片',
    front: 'back',
    src: 'https://static.iyb.tm/web/h5/passport/user/auth/oppsite.png',
  },
];

/**
 * 获取屏幕高度
 */
export function getViewHeight() {
  // server side
  if (typeof window === 'undefined') {
    return {
      maxHeight: 0,
    };
  }

  const height = (window.innerHeight || document.documentElement.clientHeight) * 0.9 - 60;

  return {
    height,
  };
}

/**
 * 请求通讯录
 */
export function requestAddressBookPage() {
  return new Promise((resolve) => {
    const params = {
      url: `${config.iybapi.host}/clientele/auth/v1/customer/alphabetList`,
    };

    fetchAPI
      .fetchResult(params)
      .then((content: any) => {
        resolve(content.result);
      })
      .catch((message: string) => {
        message && Toast.warning(message);
      });
  });
}

/**
 * 请求搜索
 * @param {string} value  搜索值
 */
export function requestSearch(value: string) {
  return new Promise((resolve) => {
    if (!value) {
      resolve([]);
      return false;
    }

    const params = {
      url: `${config.iybapi.host}/clientele/auth/v1/customer/searchWithLimit`,
      data: {
        name: value,
      },
    };

    fetchAPI
      .fetchResult(params)
      .then((content: any) => {
        resolve(content.result || []);
      })
      .catch((message: string) => {
        message && Toast.warning(message);
      });
  });
}

/**
 * 请求更多
 * @param {string} value  搜索值
 */
export function requestMore(param: any) {
  return new Promise((resolve) => {
    const params = {
      url: `${config.iybapi.host}/clientele/auth/v1/customer/queryByPage`,
      data: {
        pageSize: 5,
        ...param,
      },
    };

    fetchAPI
      .fetchResult(params)
      .then((content: any) => {
        resolve(content.result || []);
      })
      .catch((message: string) => {
        message && Toast.warning(message);
      });
  });
}

/**
 * 获取明文
 * @param {string} value  搜索值
 */
export function requestPlainText(item: any) {
  return new Promise((resolve) => {
    const params = {
      url: `${config.iybapi.host}/clientele/auth/v1/customer/certNo/plaintext`,
      data: {
        certNo: item.certNoText || item.certNo,
      },
    };

    fetchAPI
      .fetchResult(params)
      .then((content: any) => {
        if (content && content.result) {
          item.certNo = content.result;
          resolve(item);
        }
      })
      .catch((message: string) => {
        message && Toast.warning(message);
      });
  });
}

/**
 * 上传身份证证件OCR识别
 */
export function requestUploadOCR(param: any) {
  return new Promise((resolve, reject) => {
    const params = {
      url: `${config.gwiyb.host}/thirdparty/v2/ocr/idcard.json?_consumer=sky`,
      method: 'post',
      data: {
        ...param,
      },
    };

    fetchAPI
      .fetchResult(params)
      .then((content: any) => {
        if (content && content.result) {
          resolve(content.result);
        }
      })
      .catch((message: string) => {
        reject(message);
      });
  });
}
